import React, { Component } from 'react'
import { connect } from 'react-redux'
import PopupButton from 'UI/PopupButton'
import Button from 'UI/Button'
import Popup from "reactjs-popup";
import Select from 'react-select'
import { Checkbox } from 'material-ui';
import VideoHelp from 'components/UI/VideoHelp'
import { updateRegion } from 'actions/discoveryActions'
import { isSavingTabVisible } from 'actions/spendActions'

import {
    getYourFileSuccess,
    getYourFileLoading,
    resetError,
    getYourFileFailure,
    getYourFilesDetails,
    currentActiveRequest,
    UpdateRequestParameter,
    solutionScopeChanged,
    pendingChanges,
    fetchVisibleSolutionInScopeValues,
    isSpendParameterPage   ,
    saveSpendParametersOnRedirect,
    FetchUpdateFieldVisibility,
    getSccPercentageEvaluation ,
    GetRequestParameters
} from 'actions/spendActions'
import Modal from 'reboron/OutlineModal'

import { CheckboxE, PopupButtonE,RadioButtonE,SelectE } from 'UI/CustomComponents/Controls';
import { formatThousands, formatThousandsForStrings } from 'utils/Utils'
import { changeModalStyle, changeModalContentStyle, backdropStyle,path,validators,dropdownColourStyles } from 'Constants'


const changeBackdropStyle = Object.assign({}, backdropStyle);
changeBackdropStyle.zIndex = '1050';

const alertModalStyle = Object.assign({}, changeModalStyle);
alertModalStyle.zIndex = '1060';
alertModalStyle.width = '33%';

const alertModalStyleSpendParameter = Object.assign({}, changeModalStyle);
alertModalStyleSpendParameter.zIndex = '1060';
alertModalStyleSpendParameter.width = '80%';


class AccountParametersContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            disableCatalogInScope : false,
            RequestIds: [],
            fileDetails: [],
            originalState: '',
            open: false,
            isActive: false,
            waveRecalcFlag : false,
            respnseMessage: '',
            isError: false,
            fieldVisibilityData:[],
            test: JSON.stringify(this.props.spendDetails.currentActiveRequest),
            cardPaymentOption: [{ label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' }],
            selectedSolutionScope: '',
            solutionScopeOption: [],
            matchConfidenceOption: [{ label: 'High', value: 'High' }, { label: 'Medium & High', value: 'Medium,High' },{ label: 'Low, Medium & High', value: 'Low,Medium,High' }],
            matchConfidenceOptionEnablementVS: [{ label: 'High', value: 'High' }, { label: 'Medium & High', value: 'Medium,High' }],
        
            selectedMatchConfidence: 'High',
            includeSupplierDirectConnectOptions: [{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }],
            includeSupplierDirectConnectOptionsSalesVS: [{ label: '3', value: 3 }],
            
            isLoading : false,
            indirectSolutionScopeAll: [],
            //     { label: "Buying", value: "Buying" },
            //     { label: "Buying and Invoicing", value: "Buying and Invoicing" },
            //     { label: "Commerce Automation", value: "Commerce Automation" },
            //     { label: "SCC", value: "SCC" },
            //     { label: "Supplier Choice", value: "Supplier Choice" },
            //     { label: "SNAP", value: "SNAP" },
            //     { label: "DSN", value: "DSN" },
            //     { label: "RISE", value: "RISE" },                
            // ],
            solutionInScopeFlag: false,
            includeSupplierDirectConnectRadio : 0,
            selectedRegion: '',
            regionOption: [],
            modalDesc: 'Do you want to apply Solution in Scope changes to the Buyer Supplier Enablement Recommendations and Enablement Waves?',
            showPopup: false,
            pendingSolutionScope: null,
            scc_direct_spend_flag: 1,
            includeSearchSupplierOptions: [
				{ label: "Yes, as Enablement Wave", value: "Enablement_Wave" },
				{ label: "Yes, as Onboarding Workstream ", value: "Onboarding_Workstream" },
				{ label: "No", value: "No" }
			  ],
        }
        this.handleParameterCheckChanged = this.handleParameterCheckChanged.bind(this)
        this.handleSolutionScopeChange = this.handleSolutionScopeChange.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleSaveParameter = this.handleSaveParameter.bind(this);
        this.showPopupBeforeSave = this.showPopupBeforeSave.bind(this);        
        this.showModal = this.showModal.bind(this)
        this.hideModal = this.hideModal.bind(this)
        this.handleTransBuyRelButton =  this.handleTransBuyRelButton.bind(this)
        this.includeSuppDirectConnectOkClick =  this.includeSuppDirectConnectOkClick.bind(this)
        //this.closePopUp = this.closePopUp.bind(this)
        this.newVariable = 0
    }

    // showModal() {
    //     this.refs['alert'].show()
    // }

    showModal(action) {
        this.refs[action].show()
    }

    hideModal(action) {
        this.refs[action].hide()
    }

    componentWillUnmount() {		
		setTimeout(() => {
			//this.props.pendingChanges(null);
			this.props.isSpendParameterPage(false);
		}, 1000);
	}

    getDisplayRegion = (code) => {
		if (code == null) {
			return 'North America';
		}
		else {
			const normalizedCode = code.toUpperCase();
			if (normalizedCode === 'AMER' || normalizedCode === 'NAMER') {
				return 'North America';
			} else if (normalizedCode === 'EMEA') {
				return 'Europe';
			}
			else if (normalizedCode === 'LAC') {
				return 'Latin America';
			}
			else if (normalizedCode === 'APJ') {
				return 'Asia Pacific Japan';
			}
			return '';
		}
	};

	getSaveCode = (region) => {
		switch (region) {
			case 'North America':
				return 'AMER'; // Save as AMER for consistency
			case 'Europe':
				return 'EMEA';
			case 'Asia Pacific Japan':
				return 'APJ';
			case 'Latin America':
				return 'LAC';
			default:
				return 'AMER';
		}
	};

    componentDidMount() {
        // console.log("componentDidMount called")
        this.props.isSpendParameterPage(true);

        var array3 = [];
		this.props.discovery.regionsList.forEach((element) => {
			var obj = {};
			obj.label = element.Region;
			obj.value = element.Region_Code;
			array3.push(obj);
		});              

        this.setState({
            test: JSON.stringify(this.props.spendDetails.currentActiveRequest),regionOption: array3           
            //selectedRegion: this.getDisplayRegion(this.props.userData.Region)            
        })

        /////// Load Solution in scope dropdown value ////////////////////
        this.props.fetchVisibleSolutionInScopeValues().then((response) => {
            // Fetch Admin Field Visibility
            var data=[{READ_WRITE_FLAG : "R", SCREEN_FLAG : "N", TAB_NAME: "Spend Parameters"}];    
            this.props.FetchUpdateFieldVisibility(data).then((response) => {
                if (response.status === 200) {
                    this.setState({fieldVisibilityData : response.data.Result});
                }
            });  

            if (response.status === 200) {
                if (response.data.Result.length === 0) {
                    this.setState({ responseMessage: this.props.content.noRecords, isLoading: false, isError: true });
                }
                else
                {
                    console.log("api data-----------", response.data.Result)
                    var scopeValues=[];
                    if (response.data.Result !== null) {
                        var region = this.state.selectedRegion == '' ? 'AMER' : this.getSaveCode(region);
                        response.data.Result.filter(x=>x.SOLUTION_IN_SCOPE_VALUE == 'Yes' && x.REGION_CD == region && x.VALUE_STORY_TYPE == this.props.userData.ValueStoryType ).forEach(item => {
                            let value = Object.values(item)
                            scopeValues.push({ label: value[3], value: value[3] });
                        });
                    }                 

                    this.setState({ indirectSolutionScopeAll: response.data.Result, solutionScopeOption: scopeValues,isLoading: false, responseMessage: '', isError: false });
                }
            }
            else {
                this.setState({ responseMessage: this.props.content.errorMessage, isLoading: false, isError: true });
            }
        }).catch((error) => {
            this.setState({ responseMessage: this.props.content.errorMessage, isLoading: false, isError: true });
        })
        ///////////////////
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.saveSpendParametersAfterRedirect !== nextProps.saveSpendParametersAfterRedirect && nextProps.saveSpendParametersAfterRedirect) {
			//this.handleSaveParameter();
            this.setState({
                waveRecalcFlag: nextProps.waveRecalcAfterRedirect
            },()=>this.handleSaveParameter());
		}

        if (nextProps.spendDetails.currentActiveRequest !== undefined &&
            this.state.fileDetails !== undefined &&
            this.state.test !== undefined && this.state.test.length > 0) {
            var actualValue = JSON.parse(this.state.test);
            if (actualValue.DMC_ID !== this.state.fileDetails.DMC_ID) {
                this.setState({
                    test: JSON.stringify(nextProps.spendDetails.currentActiveRequest)
                })
            }


        }
        if (nextProps.spendDetails.currentActiveRequest !== this.props.fileDetails) {
            var disableCatalogInScope = false;
            if (nextProps.spendDetails.currentActiveRequest.SOLUTION_IN_SCOPE == "Supply Chain Collaboration") {
                disableCatalogInScope = true;
                nextProps.spendDetails.currentActiveRequest.CATEGORY_IN_SCOPE = false;
            }
            else {
                disableCatalogInScope = false;
            }

            this.setState({
                fileDetails: nextProps.spendDetails.currentActiveRequest, disableCatalogInScope: disableCatalogInScope
                ,selectedRegion: this.getDisplayRegion(nextProps.spendDetails.currentActiveRequest.REGION_CD)     
            })
        }
    }

    selectProductScopeAssignments(solutionInScope, region)
	{
		if(solutionInScope != 'Select Scope')
		{
			var data = this.state.indirectSolutionScopeAll.filter(d => d.SOLUTION_IN_SCOPE_NAME == solutionInScope && d.REGION_CD == region);
			var disableCatalogInScope = false;
			var CATEGORY_IN_SCOPE = false; 

			// this.props.userData.TransactionEligible = (data[0].TRAN_AN_SUPP_AUTO_ELIGIBLE == null || data[0].TRAN_AN_SUPP_AUTO_ELIGIBLE == "No" || data[0].TRAN_AN_SUPP_AUTO_ELIGIBLE == false) ? "No" : "Yes";
			// this.props.userData.UnclassifiedEligible = (data[0].UNCLASS_SUPP_AUTO_ELIGIBLE == null || data[0].UNCLASS_SUPP_AUTO_ELIGIBLE == "No" || data[0].UNCLASS_SUPP_AUTO_ELIGIBLE == false) ? "No" : "Yes";
			// this.props.userData.SCCEligible = (data[0].DIRECT_YES_SUPP_SCC_ELIGIBLE == null || data[0].DIRECT_YES_SUPP_SCC_ELIGIBLE == "No" || data[0].DIRECT_YES_SUPP_SCC_ELIGIBLE == false) ? "No" : "Yes";
			// this.props.userData.Fieldglass = (data[0].FLDG_IN_SCOPE == null || data[0].FLDG_IN_SCOPE == "No" || data[0].FLDG_IN_SCOPE == false) ? "No" : "Yes";
			// this.props.userData.FieldglassEligible = (data[0].FG_IN_AUTO_ELG == null || data[0].FG_IN_AUTO_ELG == "No" || data[0].FG_IN_AUTO_ELG == false) ? "No" : "Yes";
			// this.props.userData.SuppEligible =(data[0].SUPPLIER_ELIGIBLE == null || data[0].SUPPLIER_ELIGIBLE == "No" || data[0].SUPPLIER_ELIGIBLE == false) ? "No" : "Yes";
			// this.props.userData.CatalogScope = (data[0].CATEGORY_IN_SCOPE == null || data[0].CATEGORY_IN_SCOPE == "No" || data[0].CATEGORY_IN_SCOPE == false) ? "No" : "Yes";


			if(solutionInScope == "Supply Chain Collaboration"){
				disableCatalogInScope = true;
				//this.props.userData.CatalogScope = "No"
				CATEGORY_IN_SCOPE = false;
			}
			else
			{
				disableCatalogInScope = false;
				CATEGORY_IN_SCOPE = (data[0].CATALOG_SCOPE == null || data[0].CATALOG_SCOPE == "No" || data[0].CATALOG_SCOPE == false) ? false : true
			}

            var checkBoxState = this.state.fileDetails;
            checkBoxState.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE = (data[0].TRAN_AN_SUPP_AUTO_ELIGIBLE == null || data[0].TRAN_AN_SUPP_AUTO_ELIGIBLE == "No" || data[0].TRAN_AN_SUPP_AUTO_ELIGIBLE == false) ? false : true ;
            checkBoxState.UNCLASSIFIED_AUTOMATION_ELIGIBLE = (data[0].UNCLASS_SUPP_AUTO_ELIGIBLE == null || data[0].UNCLASS_SUPP_AUTO_ELIGIBLE == "No" || data[0].UNCLASS_SUPP_AUTO_ELIGIBLE == false) ? false : true;
            checkBoxState.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE = (data[0].DIRECT_YES_SUPP_SCC_ELIGIBLE == null || data[0].DIRECT_YES_SUPP_SCC_ELIGIBLE == "No" || data[0].DIRECT_YES_SUPP_SCC_ELIGIBLE == false) ? false : true;
            checkBoxState.FIELD_GLASS_SCOPE = (data[0].FLDG_IN_SCOPE == null || data[0].FLDG_IN_SCOPE == "No" || data[0].FLDG_IN_SCOPE == false) ? false : true;
            checkBoxState.FIELD_GLASS_ELIGIBLE = (data[0].FG_IN_AUTO_ELG == null || data[0].FG_IN_AUTO_ELG == "No" || data[0].FG_IN_AUTO_ELG == false) ? false : true;
            checkBoxState.SUPPLIER_ELIGIBLE = (data[0].TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE == null || data[0].TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE == "No" || data[0].TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE == false) ? false : true;
            checkBoxState.CATEGORY_IN_SCOPE = CATEGORY_IN_SCOPE;
            checkBoxState.OUT_SCOPE_SUSPENDED_SUPP = (data[0].OUT_SCOPE_SUSPENDED_SUPP == null || data[0].OUT_SCOPE_SUSPENDED_SUPP == "No" || data[0].OUT_SCOPE_SUSPENDED_SUPP == false) ? false : true;
            checkBoxState.DIRECT_CONNECT_WAVE = (data[0].DIRECT_CONNECT_WAVE == null || data[0].DIRECT_CONNECT_WAVE == "No" || data[0].DIRECT_CONNECT_WAVE == false) ? "No" : data[0].DIRECT_CONNECT_WAVE;
            checkBoxState.DIR_CONN_TRANS_BUY_RELN = data[0].MIN_NO_TRANS_BUY_RELN
            checkBoxState.MATCH_CONFIDENCE = data[0].MATCH_CONFIDENCE_PARAM

			this.setState({fileDetails : checkBoxState,
				disableCatalogInScope : disableCatalogInScope
			});
		}
		else
		{
			// this.props.userData.TransactionEligible = "No";
			// this.props.userData.UnclassifiedEligible = "No";
			// this.props.userData.SCCEligible = "No";
			// this.props.userData.Fieldglass = "No";
			// this.props.userData.FieldglassEligible = "No";
			// this.props.userData.SuppEligible = "No";
			// this.props.userData.CatalogScope = "No";

            var checkBoxState = this.state.fileDetails;
            checkBoxState.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE = false;
            checkBoxState.UNCLASSIFIED_AUTOMATION_ELIGIBLE = false;
            checkBoxState.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE = false;
            checkBoxState.FIELD_GLASS_SCOPE = false;
            checkBoxState.FIELD_GLASS_ELIGIBLE = false;
            checkBoxState.SUPPLIER_ELIGIBLE = false;
            checkBoxState.CATEGORY_IN_SCOPE = false;
            checkBoxState.OUT_SCOPE_SUSPENDED_SUPP = false;
            checkBoxState.DIRECT_CONNECT_WAVE = "No";
            checkBoxState.DIR_CONN_TRANS_BUY_RELN = 1;
            checkBoxState.MATCH_CONFIDENCE = 'High';

			this.setState({fileDetails : checkBoxState
			});
		}
	}


    // closePopUp(action) {
    //     if (action === "test") {
    //         var actualValue = JSON.parse(this.state.test);
    //         this.props.spendDetails.currentActiveRequest = actualValue;
    //         this.props.currentActiveRequest(actualValue);
    //         this.setState({ fileDetails: actualValue })
    //     }
    //     this.setState({ open: !this.state.open })
    //     //     }
    //     // else if (this.props.spendDetails !== undefined &&
    //     //     this.props.spendDetails.currentActiveRequest !== undefined) {
    //     //     this.setState({
    //     //         fileDetails: this.props.spendDetails.currentActiveRequest
    //     //     }, () => { this.setState({ open: !this.state.open }) })

    //     // }
    // }
    
    handleTransBuyRelButton(e) {
        this.setState({
            includeSupplierDirectConnectRadio: this.state.fileDetails.DIR_CONN_TRANS_BUY_RELN
        },()=> this.showModal("IncludeSupplierDirectConnect"));
    }

    handleParameterCheckChanged(e) {

        // if(e.target.checked)
        // {
        //     this.showModal("IncludeSupplierDirectConnect");

        // }
        var checkBoxState = this.state.fileDetails;


        switch (e.target.name) {
            case this.props.content.supplierEligible:
                checkBoxState.SUPPLIER_ELIGIBLE = e.target.checked;
                break;
            case this.props.content.catalogInScope:
                checkBoxState.CATEGORY_IN_SCOPE = e.target.checked;
                break;
            case this.props.content.transactionEligible:
                checkBoxState.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE = e.target.checked;
                break;
            case this.props.content.unclassifiedEligible:
                checkBoxState.UNCLASSIFIED_AUTOMATION_ELIGIBLE = e.target.checked;
                break;
            case this.props.content.sCCEligible:
                checkBoxState.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE = e.target.checked;
                break;
            case this.props.content.fieldglass:
                checkBoxState.FIELD_GLASS_SCOPE = e.target.checked;
                checkBoxState.FIELD_GLASS_ELIGIBLE = (e.target.checked === false ? false : this.state.fileDetails.FIELD_GLASS_ELIGIBLE);
                break;
            case this.props.content.fieldglassEligible:
                checkBoxState.FIELD_GLASS_ELIGIBLE = (this.state.fileDetails.FIELD_GLASS_SCOPE === false ? false : e.target.checked);
                break;
            case this.props.content.cardPaymentInScope:
                checkBoxState.CARD_PAYMENT_INSCOPE = e.target.checked;
                break;
            case this.props.content.enforcedOutScopeSuppliers:
                checkBoxState.OUT_SCOPE_SUSPENDED_SUPP = e.target.checked;
                break;
            case this.props.content.includeSearchSupplier:
                checkBoxState.DIRECT_CONNECT_WAVE = e.target.value;
                break;
        }
        this.props.pendingChanges(true)
        this.setState({ fileDetails: checkBoxState });

    }

    handleParameterDropdownChanged(selectedValue) {
        if(selectedValue == 'Onboarding_Workstream')
            this.props.spendDetails.currentActiveRequest.ENABLEMENT_STRATEGY_FOCUS = 'enablementType';
        else
            this.props.spendDetails.currentActiveRequest.ENABLEMENT_STRATEGY_FOCUS = 'l4Industry';
        
        const fileDetails = this.state.fileDetails;
        fileDetails.DIRECT_CONNECT_WAVE = selectedValue;
        this.props.pendingChanges(true);
        this.setState({ fileDetails });
      }

    onChange(e) {
        var textBoxState = this.state.fileDetails;

        textBoxState.ANNUAL_TRANSACTION_MAX = e.target.value;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    onTermRationalizationChange(e) {
        var textBoxState = this.state.fileDetails;

        textBoxState.TERMS_RATIONALIZATION_THRESHOLD = e.target.value;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    onSpotBuyThresholdChange(e) {
        var textBoxState = this.state.fileDetails;

        // textBoxState.SPOT_BUY_ELIGIBLE_THRESHOLD = parseFloat(e.target.value.replace(/,/g, ''));
        textBoxState.SPOT_BUY_ELIGIBLE_THRESHOLD = e.target.value;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    onAvgInvSpendThresholdChange(e) {
        var textBoxState = this.state.fileDetails;

        textBoxState.AVG_INV_SPEND_TRANS_THRESHOLD = e.target.value;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    onLowInvoiceCountThresholdChange(e) {
        var textBoxState = this.state.fileDetails;

        textBoxState.LOW_INVOICE_COUNT_THRESHOLD = e.target.value;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    onCardPaymentInScopeChange(value) {
        var textBoxState = this.state.fileDetails;

        textBoxState.CARD_PAYMENT_INSCOPE = value === "Yes" ? true : false;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    onDiscountThresholdChange(e) {
        var textBoxState = this.state.fileDetails;

        textBoxState.DISCOUNT_THRESHOLD = e.target.value;
        this.props.pendingChanges(true)
        this.setState({
            fileDetails: textBoxState
        });
    }

    showPopupBeforeSave(){
        this.showModal("SpendParameter");
    }

    saveSpendParamWithEnableStrategy(){
        this.setState({
            waveRecalcFlag: true
        },()=>this.handleSaveParameter());
    }

    saveSpendParamWithoutEnableStrategy(){
        this.setState({
            waveRecalcFlag: false
        },()=>this.handleSaveParameter());
    }

    handleSaveParameter() {
        this.hideModal("alert")
        this.hideModal("SpendParameter")
        this.setState({ respnseMessage: '', isError: false,isLoading:true })

        this.props.getYourFileLoading(true);
        
        //console.log("filedetails :", this.state.fileDetails);

        var currentUpdate = this.state.fileDetails.ANNUAL_TRANSACTION_MAX.toString().replace(/^\D+/g, '');
        this.state.fileDetails.ANNUAL_TRANSACTION_MAX = currentUpdate

        var termRationalizationValue = this.state.fileDetails.TERMS_RATIONALIZATION_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.TERMS_RATIONALIZATION_THRESHOLD = termRationalizationValue

        var discountThresholdValue = this.state.fileDetails.DISCOUNT_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.DISCOUNT_THRESHOLD = discountThresholdValue

        var lowInvoiceCountValue = this.state.fileDetails.LOW_INVOICE_COUNT_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.LOW_INVOICE_COUNT_THRESHOLD = lowInvoiceCountValue

        var cardPaymentInScopeValue = this.state.fileDetails.CARD_PAYMENT_INSCOPE;
        this.state.fileDetails.CARD_PAYMENT_INSCOPE = cardPaymentInScopeValue

        var termRationalizationValue = this.state.fileDetails.SPOT_BUY_ELIGIBLE_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.SPOT_BUY_ELIGIBLE_THRESHOLD = termRationalizationValue

        var termRationalizationValue = this.state.fileDetails.AVG_INV_SPEND_TRANS_THRESHOLD.toString().replace(',', '');
        this.state.fileDetails.AVG_INV_SPEND_TRANS_THRESHOLD = termRationalizationValue

        var solutionInScope = this.state.fileDetails.SOLUTION_IN_SCOPE;
        this.state.fileDetails.SOLUTION_IN_SCOPE = solutionInScope

        var includeSuppDirectConnect = this.state.fileDetails.DIR_CONN_TRANS_BUY_RELN;
        this.state.fileDetails.DIR_CONN_TRANS_BUY_RELN = includeSuppDirectConnect

        this.state.fileDetails.REGION_CD = this.getSaveCode(this.state.selectedRegion)

        var param = {RequestData : this.state.fileDetails , WaveRecalcFlag : this.state.waveRecalcFlag, Region_Cd : this.state.fileDetails.REGION_CD,SCC_DIRECT_SPEND_FLG:this.state.scc_direct_spend_flag};

        this.props.UpdateRequestParameter(param).then(function(response) {
            if (response.status === 200) {

                //Set Saving Tab Visible (True / False)
                this.props.fetchVisibleSolutionInScopeValues().then((response) => {
                    if (response.status === 200) {
                        if (response.data.Result.length > 0) {
                            const isSavingVisible = response.data.Result.find(item => item.REGION_CD === this.state.fileDetails.REGION_CD && item.SOLUTION_IN_SCOPE_NAME === this.state.fileDetails.SOLUTION_IN_SCOPE && item.VALUE_STORY_TYPE ===this.props.userData.ValueStoryType).RISE_SAVING;
                            this.props.isSavingTabVisible(isSavingVisible);
                        }
                    }
                });

                this.setState({
                    isError: false,
                    respnseMessage: 'Parameter/s updated successfully',
                    test: JSON.stringify(this.state.fileDetails),
                    solutionInScopeFlag: false,
                    isLoading: false
                })
                this.props.getYourFileLoading(false);
                this.props.updateRegion(this.getSaveCode(this.state.selectedRegion));
                this.props.currentActiveRequest(this.state.fileDetails);
                this.props.pendingChanges(null)
                //this.setState({ open: !this.state.open })
                //this.closePopUp('close');
            }
            else {
                this.setState({
                    isError: true,
                    respnseMessage: 'An error has occured',
                    isLoading: false
                })
            }
            this.props.saveSpendParametersOnRedirect(false);
        }.bind(this)).catch((error) => {
            this.setState({
                isError: true,
                respnseMessage: 'An error has occured',
                isLoading: false
            })
        })
    }

    handleSolutionScopeChange(value) {
        if (value.label === "Supply Chain Collaboration") {

        var request = { DMCID: this.props.spendDetails.currentActiveRequest.DMC_ID, VSID: this.props.spendDetails.currentActiveRequest.VS_ID, Email: this.props.user.user.Email }
           this.props.getSccPercentageEvaluation(request).then((result) => {
                if (result.status === 200) {
                    if (result.data.Result[0].LOGIC == 'TRUE') {

                        this.setState({
                            showPopup: true,
                            pendingSolutionScope:value
                        });
                        return; // stop here until user chooses

                    }
                    else
                    {
                        this.executeSolutionScopeChange(value);
                    }
                }
            }).catch((error) => {
            });

            
            // Proceed directly if not "Supply Chain Collaboration"
        }
        else{
            this.executeSolutionScopeChange(value);
        }
    }
      
      handlePopupChoiceForSolutionScope(choiceValue) {
        this.setState(
          {
            showPopup: false,
            scc_direct_spend_flag: choiceValue, // store 1 / 2 / 3 (Yes / No / NA)
          },
          () => {
            // Continue with main logic after popup closes
            this.executeSolutionScopeChange(this.state.pendingSolutionScope);
          }
        );
      }
      
      executeSolutionScopeChange(value) {
        var objFileDetails = this.state.fileDetails;
        var disableCatalogInScope = false;
      
        if (value.label === "Supply Chain Collaboration") {
          disableCatalogInScope = true;
          objFileDetails.CATEGORY_IN_SCOPE = false;
        } else {
          disableCatalogInScope = false;
        }
      
        objFileDetails.SOLUTION_IN_SCOPE = value.label;
        this.props.solutionScopeChanged(value.label);
        this.props.pendingChanges(true);
      
        this.setState(
          {
            disableCatalogInScope: disableCatalogInScope,
            fileDetails: objFileDetails,
            isError: true,
            respnseMessage:
              "Warning! Buyer Supplier Enablement Recommendations will be changed.",
            solutionInScopeFlag: true,
          },
          () =>
            this.selectProductScopeAssignments(
              value.label,
              this.getSaveCode(this.state.selectedRegion)
            )
        );
      }
      

    handleMatchConfidenceChange(value) {
        this.props.pendingChanges(true);
        var objFileDetails = this.state.fileDetails;
        objFileDetails.MATCH_CONFIDENCE = value;
        this.setState({
            fileDetails: objFileDetails ,  selectedMatchConfidence: value
        });   
    }
    
    handleincludeSuppDirectConnectChange(value) {        
        this.props.pendingChanges(true);
        var objFileDetails = this.state.fileDetails;
        objFileDetails.DIR_CONN_TRANS_BUY_RELN = value;
        this.setState({
            fileDetails: objFileDetails ,  includeSupplierDirectConnectRadio: value
        });        
    }

    includeSuppDirectConnectOkClick()
    {
        this.props.pendingChanges(true);
        var objFileDetails = this.state.fileDetails;
        objFileDetails.DIR_CONN_TRANS_BUY_RELN = this.state.includeSupplierDirectConnectRadio;
        this.setState({
            fileDetails: objFileDetails
        },()=> this.hideModal("IncludeSupplierDirectConnect"));
    }

    closeIncludeSuppDirectConnectPopup(){
        this.setState({
            includeSupplierDirectConnectRadio: this.state.fileDetails.DIR_CONN_TRANS_BUY_RELN
        },()=> this.hideModal("IncludeSupplierDirectConnect"));        
    }

    handleRegionChange(value) {
		this.selectProductScopeAssignments(this.state.fileDetails.SOLUTION_IN_SCOPE,value);
		this.props.pendingChanges(true);
        var objFileDetails = this.state.fileDetails;
        objFileDetails.REGION_CD = value
        this.setState({
            fileDetails: objFileDetails,
            selectedRegion: this.getDisplayRegion(value)
        });
		this.setState({ selectedRegion: this.getDisplayRegion(value)});
	}

    render() {
        var displayInfoDesc = (itemDesc) => {
            return (
                <div>
                    <Popup className="report-tooltip"
                        trigger={<span className='value__information' />}
                        position="bottom right"
                        on="hover"
                    >
                        {itemDesc}
                    </Popup>
                </div>
            )
        };
        //onClick={() => this.showModal('AccountParameters')}

        return (
            this.props.spendDetails !== undefined && this.props.spendDetails.currentActiveRequest !== undefined && this.props.spendDetails.currentActiveRequest !== "" ?
                <div className="grid-x">
                    <div className="medium-11 tab-title">{('Spend Paramater')}{<VideoHelp screen={{ module: 'Spend', screenName: 'Your Spend File >> Spend Parameters' }} />}</div>
                    <div className="medium-12 pb20 pt20">
                        <div className="grid-x">
                            <div className="medium-1"></div>                            
                            <div style={{ display: 'flex', justifyContent: 'center' }} className="medium-10">
                                {this.state.isError ?
                                    <div style={{ margin: '0 0 0.5rem', color: 'red' }}>{this.state.respnseMessage}</div> :
                                    <div style={{ margin: '0 0 0.5rem', color: '#4fb81c' }}>{this.state.respnseMessage}</div>
                                }
                                {(this.state.isLoading) ?
                                    <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                                        src={path + `images/ajax-loader.gif`} alt="" />
                                    : null
                                }
                            </div>
                            <div style={{ paddingLeft: '5px' }} className="float-left medium-1">
                                <button
                                    className='hand-cursor'
                                    type="submit"
                                    //onClick={this.state.solutionInScopeFlag ? this.showModal : this.handleSaveParameter}
                                    //onClick={this.state.solutionInScopeFlag ? this.showModal("alert") : this.showPopupBeforeSave}
                                    onClick={this.showPopupBeforeSave}
                                    content={this.props.content.saveButton}
                                    disabled={this.state.isLoading}  // 👈 disables when isLoading = true
                                    style={{
                                        opacity: this.state.isLoading ? 0.5 : 1, // optional visual feedback
                                        pointerEvents: this.state.isLoading ? 'none' : 'auto'
                                    }}
                                    color ><img width="25" src="images/save_active.svg" /></button>
                            </div>
                        </div>
                    </div>
                    <div className="medium-1"></div>
                    <div style={{ backgroundColor: '#fafafa' }} className="medium-10">
                        <div className="grid-x">                           
                            <div className="medium-12 title pt15 pl5" style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                                <span>How to enable suppliers</span>
                                <span className="pl5">
                                    {displayInfoDesc(
                                        'These parameters inputs impact how Enablement Recommendations are assigned and flow through to Onboarding Recommendations.'
                                    )}
                                </span>
                            </div>
                            
                            <div className="medium-12">
                            <div className="grid-x pt5">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                Regional Model
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc('The Regional Model field is auto populated based on the user region by default.  This field selects the Regional Model used to populate the Enablement Recommendations which flow through to the Onboarding Workstream and Enablement Waves.')}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3">
                                        <Select
                                            className="border-with-DD dropDownContent"
                                            id='discovery.Region'
                                            autocomplete='true'
                                            value={this.state.regionOption.filter(option => option.value === this.state.selectedRegion)}
                                            onChange={(value) => this.handleRegionChange(this.getSaveCode(value.value))}
                                            options={this.state.regionOption}
                                            isSearchable={false}
                                            noOptionsMessage={() => null} />
                                    </div>
                                </div>
                                <div className="grid-x pt5">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.inScopeSolution}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.inScopeSolution)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3">
  <Select
    className="border-with-DD dropDownContent"
    id="aribaNetworkMatched"
    autocomplete="true"
    value={this.state.solutionScopeOption.filter(
      (option) => option.value === this.state.fileDetails.SOLUTION_IN_SCOPE
    )}
    onChange={(value) => this.handleSolutionScopeChange(value)}
    options={this.state.solutionScopeOption}
    isSearchable={false}
    noOptionsMessage={() => null}
  />

  {/* Popup */}
  {this.state.showPopup && (
                                            <div className="popup-overlay">
                                                <div className="popup-box">
                                                    <p>Are direct spend suppliers identified in the spend file by having Direct Spend marked yes? <br />Note: To be considered for SCC enablement supplier must be marked as Direct Spend.</p>
                                                    <div className="popup-buttons">
                                                        {[
                                                            { label: 'Please update Direct Spend for all supplier to Yes', value: 3 },
                                                            { label: 'Yes - Direct Spend data is correct in customer data', value: 1 },
                                                            { label: 'No - User will update Direct Spend data manually', value: 2 },
                                                        ].map((choice) => (
                                                            <button
                                                                key={choice.value}
                                                                className="popup-btn"
                                                                onClick={() => this.handlePopupChoiceForSolutionScope(choice.value)}
                                                            >
                                                                {choice.label}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
  )}
</div>

                                </div>
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.catalogInScope}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.catalogInScope)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE disabled={this.state.disableCatalogInScope} iconStyle={{ fill: '#008fd3' }} id={this.props.content.catalogInScope}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.CATEGORY_IN_SCOPE !== undefined ? this.state.fileDetails.CATEGORY_IN_SCOPE : false} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                name={this.props.content.catalogInScope} value={this.props.content.catalogInScope} />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.transactionEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.transactionEligibleDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.transactionEligible}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE !== undefined ? this.state.fileDetails.TRANSACTION_ANSUPPLIERS_AUTOMATION_ELIGIBLE : false} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                name={this.props.content.transactionEligible} value={this.props.content.transactionEligible} />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.unclassifiedEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.unclassifiedEligible)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.unclassifiedEligible}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.UNCLASSIFIED_AUTOMATION_ELIGIBLE !== undefined ? this.state.fileDetails.UNCLASSIFIED_AUTOMATION_ELIGIBLE : false}
                                                onClick={(e) => this.handleParameterCheckChanged(e)}
                                                name={this.props.content.unclassifiedEligible}
                                                value={this.props.content.unclassifiedEligible} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.supplierEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.supplierEligible)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.supplierEligible}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.SUPPLIER_ELIGIBLE !== undefined ? this.state.fileDetails.SUPPLIER_ELIGIBLE : false} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                name={this.props.content.supplierEligible} value={this.props.content.supplierEligible} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.enforcedOutScopeSuppliers}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.enforcedOutScopeSuppliersDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                        <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.enforcedOutScopeSuppliers} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.OUT_SCOPE_SUSPENDED_SUPP !== undefined ? this.state.fileDetails.OUT_SCOPE_SUSPENDED_SUPP : false}
                                                name={this.props.content.enforcedOutScopeSuppliers} value={this.props.content.enforcedOutScopeSuppliers} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {((this.state.fieldVisibilityData.length > 0 &&
                                this.state.fieldVisibilityData.some(el => el.FIELD_NAME == this.props.content.includeSearchSupplier && el.VISIBLE_FLAG == 'Yes')) && this.state.fileDetails.SOLUTION_IN_SCOPE != 'Supply Chain Collaboration') ?

                                <>
                                    <div className="medium-12 title pt15 pl5" style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                                        <span>Direct Connect</span>
                                        <span className="pl5">
                                            {displayInfoDesc(
                                                'The Direct Connect Parameters control if a Direct Connect wave is created and which suppliers are added to the wave. This is changed by adjusting the minimum number of transacting buyer relationships and match confidence levels.'
                                            )}
                                        </span>
                                    </div>
                                {/* </>                                
                                : null}
                            {(this.state.fieldVisibilityData.length > 0 && 
                                this.state.fieldVisibilityData.some(el => el.FIELD_NAME == this.props.content.includeSearchSupplier && el.VISIBLE_FLAG == 'Yes')) && this.state.fileDetails.SOLUTION_IN_SCOPE != 'Supply Chain Collaboration'? */}
                           
                            <div className="medium-12">
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                Include Direct Connect
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.includeSearchSupplierDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                            <div className="medium-3" style={{ border: 'solid 1px #e1e1e1', borderRadius: '3px' }}>
                                                <div className="medium-3">
                                                    <Select
                                                        className="border-with-DD dropDownContent"
                                                        id={this.props.content.includeSearchSupplier}
                                                        name={this.props.content.includeSearchSupplier}
                                                        value={this.state.includeSearchSupplierOptions.find(
                                                            option => option.value === this.state.fileDetails.DIRECT_CONNECT_WAVE
                                                        )}
                                                        onChange={value => this.handleParameterDropdownChanged(value.value)}
                                                        //isDisabled={this.props.userData.ValueStoryType === "Sales"}
                                                        options={this.state.includeSearchSupplierOptions}
                                                        isSearchable={false}
                                                        noOptionsMessage={() => null}
                                                    />
                                                </div>
                                            </div>
                                            
                                </div>
                            </div>                            
                            {/* :null}

                        {(this.state.fieldVisibilityData.length > 0 && 
                                this.state.fieldVisibilityData.some(el => el.FIELD_NAME == this.props.content.includeSearchSupplier && el.VISIBLE_FLAG == 'Yes')) && this.state.fileDetails.SOLUTION_IN_SCOPE != 'Supply Chain Collaboration'? */}
                            
                                <div className="medium-12">
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                Minimum # of transacting buyer relationships
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                 {displayInfoDesc(this.props.content.includeSuppDirectConnectDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3" style={{border: 'solid 1px #e1e1e1', borderRadius: '3px'}}>
                                        {/* 
                                            <Select
                                            className="border-with-DD dropDownContent"
                                            id='includeSuppDirectConnect'
                                            autocomplete='true'
                                            value={this.state.includeSupplierDirectConnectOptions.filter(
                                                option => option.value === this.state.fileDetails.DIR_CONN_TRANS_BUY_RELN
                                            )}
                                            onChange={value => this.handleincludeSuppDirectConnectChange(value)}
                                            options={this.state.includeSupplierDirectConnectOptions}
                                            isSearchable={false}
                                            noOptionsMessage={() => null} /> */}
                                            {/* <div className='medium-4'>
                                                <div className="subHeader pl20 pt10 float-left" style={{fontSize:'smaller'}}>Transacting Buyer Relationship </div>
                                                 <div className="float-left pl20" style={{width:'120px'}}>
                                                    <Select
                                                        className="border-with-DD dropDownContent"
                                                        id='includeSuppDirectConnect'
                                                        //autocomplete='true'
                                                        value={this.state.includeSupplierDirectConnectOptions.filter(
                                                            option => option.value === this.state.fileDetails.DIR_CONN_TRANS_BUY_RELN
                                                        )}
                                                        onChange={value => this.handleincludeSuppDirectConnectChange(value.value)}
                                                        options={this.state.includeSupplierDirectConnectOptions}
                                                        isSearchable={false}
                                                        noOptionsMessage={() => null} />
                                                </div> 
                                            </div> */}

                                            {/* <div className="float-left"><Button
                                            content={"Change Transacting Buyer Relationships"}
                                            onClick={this.handleTransBuyRelButton}
                                            color /></div> */}

                                            <div className="medium-3">
                                                <Select
                                                    className="border-with-DD dropDownContent"
                                                    id='includeSuppDirectConnect'
                                                    //autocomplete='true'
                                                    value={this.state.includeSupplierDirectConnectOptions.filter(
                                                        option => option.value === this.state.fileDetails.DIR_CONN_TRANS_BUY_RELN
                                                    )}
                                                    //isDisabled = {this.props.userData.ValueStoryType == 'Sales'}
                                                    onChange={value => this.handleincludeSuppDirectConnectChange(value.value)}
                                                    options={this.props.userData.ValueStoryType == 'Sales' ? this.state.includeSupplierDirectConnectOptionsSalesVS :this.state.includeSupplierDirectConnectOptions}                                                    
                                                    isSearchable={false}
                                                    noOptionsMessage={() => null} />
                                            </div>

                                    </div>
                                </div>
                            </div>                                                      
                            {/* :null}
                            
                            {(this.state.fieldVisibilityData.length > 0 && 
                                this.state.fieldVisibilityData.some(el => el.FIELD_NAME == this.props.content.includeSearchSupplier && el.VISIBLE_FLAG == 'Yes')) && this.state.fileDetails.SOLUTION_IN_SCOPE != 'Supply Chain Collaboration'? */}
                            
                            <div className="medium-12">
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                            Match Confidence
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc('Match Confidence')}                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3">                                        
                                        <Select
                                            className="border-with-DD dropDownContent"
                                            id='aribaNetworkMatched'
                                            autocomplete='true'
                                            value={this.state.matchConfidenceOption.filter(
                                                option => option.value === this.state.fileDetails.MATCH_CONFIDENCE
                                            )}
                                            //isDisabled = {this.props.userData.ValueStoryType == 'Sales'}
                                            onChange={value => this.handleMatchConfidenceChange(value.value)}
                                            options={this.props.userData.ValueStoryType == 'Sales' ? this.state.matchConfidenceOption : this.state.matchConfidenceOptionEnablementVS}                                            
                                            isSearchable={false}
                                            noOptionsMessage={() => null} />                                        
                                    </div>
                                </div>
                            </div>                            
                            {/* :null} */}
                            </>                                
                                : null}

                            <div style={{ fontWeight: 'bold' }} className="medium-12 pt15 pl5 title">
                                {this.props.content.productScope}
                            </div>
                            <div className="medium-12 pt5">
                             

                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.sCCEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.sCCEligibleDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.sCCEligible} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE !== undefined ? this.state.fileDetails.WHENDIRECT_SUPPLIER_SCC_ELIGIBLE : false}
                                                name={this.props.content.sCCEligible} value={this.props.content.sCCEligible} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.fieldglass}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.fieldglassDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.fieldglass} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.FIELD_GLASS_SCOPE !== undefined ? this.state.fileDetails.FIELD_GLASS_SCOPE : false}
                                                name={this.props.content.fieldglass} value={this.props.content.fieldglass} />
                                        </div>
                                    </div>
                                </div>
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.fieldglassEligible}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.fieldglassEligibleDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                        {/* <CheckboxE iconStyle={{ fill: this.state.fileDetails.FIELD_GLASS_ELIGIBLE === true ? '#008fd3' : '#f7f7f7' }} id={this.props.content.fieldglassEligible} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.FIELD_GLASS_ELIGIBLE !== undefined ? this.state.fileDetails.FIELD_GLASS_ELIGIBLE : false}
                                                name={this.props.content.fieldglassEligible} value={this.props.content.fieldglassEligible} /> */}
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.fieldglassEligible} onClick={(e) => this.handleParameterCheckChanged(e)}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.FIELD_GLASS_ELIGIBLE !== undefined ? this.state.fileDetails.FIELD_GLASS_ELIGIBLE : false}
                                                name={this.props.content.fieldglassEligible} value={this.props.content.fieldglassEligible} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            { 1 == 2?
                            <>
                            <div style={{ fontWeight: 'bold' }} className="medium-12 title pt15 pl5">
                                {this.props.content.workingCapitalScope}
                            </div>
                            <div className="medium-12">
                                <div className="grid-x pt5">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.termRationalizationThreshold}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.termsRationalizationDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3">
                                        <input className="box-input"
                                            value={this.state.fileDetails !== undefined
                                                && this.state.fileDetails.TERMS_RATIONALIZATION_THRESHOLD !== undefined
                                                ? formatThousandsForStrings(this.state.fileDetails.TERMS_RATIONALIZATION_THRESHOLD)
                                                : 0}
                                            onChange={(e) => this.onTermRationalizationChange(e)} type="text" id="maxvalue" />
                                    </div>
                                </div>
                            </div>
                            <div className="medium-12">
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.discountThreshold}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.discountThresholdDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3">
                                        <input className="box-input"
                                            value={this.state.fileDetails !== undefined
                                                && this.state.fileDetails.DISCOUNT_THRESHOLD !== undefined
                                                ? formatThousandsForStrings(this.state.fileDetails.DISCOUNT_THRESHOLD)
                                                : 0}
                                            onChange={(e) => this.onDiscountThresholdChange(e)} type="text" id="maxvalue" />
                                    </div>
                                </div>
                            </div>
                            <div className="medium-12">
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.lowInvoiceCountThreshold}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.lowInvoiceCountDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3">
                                        <input className="box-input"
                                            value={this.state.fileDetails !== undefined
                                                && this.state.fileDetails.LOW_INVOICE_COUNT_THRESHOLD !== undefined
                                                ? formatThousandsForStrings(this.state.fileDetails.LOW_INVOICE_COUNT_THRESHOLD)
                                                : 0}
                                            onChange={(e) => this.onLowInvoiceCountThresholdChange(e)} type="text" id="maxvalue" />
                                    </div>
                                </div>
                            </div>
                            <div className="medium-12">
                                <div className="grid-x">
                                    <div className="medium-9 box-title">
                                        <div className="grid-x grid-padding-x">
                                            <div className="medium-10">
                                                {this.props.content.cardPaymentInScope}
                                            </div>
                                            <div className="medium-2">
                                                <div className="float-right pr20">
                                                    {displayInfoDesc(this.props.content.cardPaymentInScopeDesc)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="medium-3 product-box">
                                        <div className="pt10">
                                            <CheckboxE iconStyle={{ fill: '#008fd3' }} id={this.props.content.cardPaymentInScope}
                                                checked={this.state.fileDetails !== undefined && this.state.fileDetails.CARD_PAYMENT_INSCOPE !== undefined ? this.state.fileDetails.CARD_PAYMENT_INSCOPE : false}
                                                onClick={(e) => this.handleParameterCheckChanged(e)}
                                                name={this.props.content.cardPaymentInScope} value={this.props.content.cardPaymentInScope} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div style={{ fontWeight: 'bold' }} className="medium-12 title pt15 pl5">
                                    {this.props.content.spotBuy}
                                </div>
                                <div className="medium-12">
                                    <div className="grid-x pt5">
                                        <div className="medium-9 box-title">
                                            <div className="grid-x grid-padding-x">
                                                <div className="medium-10">
                                                    {this.props.content.spotBuyThreshold}
                                                </div>
                                                <div className="medium-2">
                                                    <div className="float-right pr20">
                                                        {displayInfoDesc(this.props.content.spotBuyDesc)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="medium-3">
                                            <input className="box-input"
                                                value={this.state.fileDetails !== undefined
                                                    && this.state.fileDetails.SPOT_BUY_ELIGIBLE_THRESHOLD !== undefined
                                                    ? formatThousandsForStrings(this.state.fileDetails.SPOT_BUY_ELIGIBLE_THRESHOLD)
                                                    : 0}
                                                onChange={(e) => this.onSpotBuyThresholdChange(e)} type="text" id="maxvalue" />
                                        </div>
                                    </div>
                                </div>
                                <div className="medium-12">
                                    <div className="grid-x">
                                        <div className="medium-9 box-title">
                                            <div className="grid-x grid-padding-x">
                                                <div className="medium-10">
                                                    {this.props.content.avgInvoiceThreshold}
                                                </div>
                                                <div className="medium-2">
                                                    <div className="float-right pr20">
                                                        {displayInfoDesc(this.props.content.avgInvoiceDesc)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="medium-3">
                                            <input className="box-input"
                                                value={this.state.fileDetails !== undefined
                                                    && this.state.fileDetails.AVG_INV_SPEND_TRANS_THRESHOLD !== undefined
                                                    ? formatThousandsForStrings(this.state.fileDetails.AVG_INV_SPEND_TRANS_THRESHOLD)
                                                    : 0}
                                                onChange={(e) => this.onAvgInvSpendThresholdChange(e)} type="text" id="maxvalue" />
                                        </div>
                                    </div>
                                </div>
                                </>
                                :null}

                                {/* <div style={{ fontWeight: 'bold' }} className="medium-12 pt15 pl5 title">
                                    {this.props.content.title}
                                </div>
                                <div className="medium-12 pt5">
                                    <div className="grid-x">
                                        <div className="medium-9 box-title">
                                            <div className="grid-x grid-padding-x">
                                                <div className="medium-10">
                                                    {this.props.content.annualTransactionMax}
                                                </div>
                                                <div className="medium-2">
                                                    <div className="float-right pr20">
                                                        {displayInfoDesc(this.props.content.annualTransactionMaxDesc)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="medium-3">
                                            <input className="box-input"
                                                value={this.state.fileDetails !== undefined
                                                    && this.state.fileDetails.ANNUAL_TRANSACTION_MAX !== undefined
                                                    ? this.state.fileDetails.ANNUAL_TRANSACTION_MAX
                                                    : (this.state.fileDetails !== undefined
                                                        && this.state.fileDetails.ANNUAL_TRANSACTION_MAX !== undefined) ? this.state.fileDetails.ANNUAL_TRANSACTION_MAX : 0}
                                                onChange={(e) => this.onChange(e)} type="text" id="maxvalue" />
                                        </div>
                                    </div>
                                </div> */}


                            {/* </div> */}
                        </div>
                    </div>
                    <div className="medium-1"></div>
                    <div>
                        <Modal
                            ref="alert"
                            modalStyle={alertModalStyle}
                            contentStyle={changeModalContentStyle}
                            backdropStyle={changeBackdropStyle}
                        >
                            <div className="grid-x grid-padding-x change-popup">
                                <div className="medium-12">
                                    <button onClick={() => this.hideModal("alert")} className="close" />
                                </div>
                                <div className="medium-12 pt15">
                                    {this.state.modalDesc}
                                </div>
                                <div className="medium-12 popupOkBtn pt10">
                                    <div className="float-right">
                                        <div className="float-left"><Button
                                            content={"Yes"}
                                            onClick={this.handleSaveParameter}
                                            color /></div>
                                        <div className="float-left"><Button
                                            content={"Close"}
                                            onClick={() => this.hideModal("alert")}
                                            color /></div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div>
                    <Modal
                        ref="SpendParameter"
                        modalStyle={alertModalStyleSpendParameter}
                        contentStyle={changeModalContentStyle}
                        backdropStyle={changeBackdropStyle}
                    >
                        <div className="grid-x grid-padding-x change-popup">
                            <div className="medium-12">
                                <button onClick={() => this.hideModal("SpendParameter")} className="close" />
                            </div>
                            <div className="medium-12 pt30">
                            {this.props.tabMessage.toggleVSMessage}
                            </div>                            
							<div className="grid-x medium-12 mt20">
								<div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleSpendParamYesButtonWithStrategy}
                                        //onClick={() => this.continueSpendParameterNavigation("SpendParameter")}
                                        onClick={this.saveSpendParamWithEnableStrategy.bind(this)}
                                        color />
                                </div>  
                                <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleSpendParamYesButton}
                                        //onClick={() => this.continueSpendParameterNavigation("SpendParameter")}
                                        onClick={this.saveSpendParamWithoutEnableStrategy.bind(this)}
                                        color />
                                </div>                                
                                {/* <div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleVSNoButton}
                                        onClick={() => this.closeModal("SpendParameter")} 
                                        color />
                                </div> */}
								<div>
                                    <Button
                                        className="float-left"
                                        type="submit"
                                        disabled={this.state.isLoading}
                                        content={this.props.tabMessage.toggleVSRevertButton}
                                        onClick={() => this.hideModal("SpendParameter")}
                                        color />
                                </div>
                            </div> 
                        </div>
                    </Modal>
                </div>
                <div>
                    <Modal
                        ref="IncludeSupplierDirectConnect"
                        modalStyle={alertModalStyleSpendParameter}
                        contentStyle={changeModalContentStyle}                        
                    >
                            <div className="grid-x grid-padding-x change-popup">
                                <div className="medium-12">
                                    <button onClick={() => this.hideModal("IncludeSupplierDirectConnect")} className="close" />
                                </div>

                                <div className="grid-x medium-12 mt20">
                                    <div className="medium-12 plt"><span><RadioButtonE className='radioButton'
                                        checked={this.state.includeSupplierDirectConnectRadio == '1'}
                                        id={'DIR_CONN_TRANS_BUY_RELN1'}
                                        value={'1'}
                                        label="Include supplier in Direct Connect Wave if the supplier has greater than of equal to one transacting buyer relationship"
                                        onClick={value => this.handleincludeSuppDirectConnectChange(1)}
                                        color="default"
                                    /></span></div>
                                </div>
                                <div className="grid-x medium-12 mt20">
                                    <div className="medium-12 plt"><span><RadioButtonE className='radioButton'
                                        checked={this.state.includeSupplierDirectConnectRadio == '2'}
                                        id={'DIR_CONN_TRANS_BUY_RELN2'}
                                        value={'2'}
                                        label="Include supplier in Direct Connect Wave if the supplier has greater than of equal to two transacting buyer relationships"
                                        onClick={value => this.handleincludeSuppDirectConnectChange(2)}
                                        color="default"
                                    /></span></div>
                                </div>
                                <div className="grid-x medium-12 mt20">
                                    <div className="float-left"><Button
                                        content={"Ok"}
                                        onClick={() => this.includeSuppDirectConnectOkClick()}
                                        color /></div>
                                </div>
                            </div>                        
                    </Modal>
                </div>
                </div >
                :
                <div className="grid-x">
                    <div className="medium-12">
                        {this.props.content.noActiveRequestFile}
                    </div >
                </div >
        )
    }
}
const mapStateToProps = state => {
    return {
        // language: state.language,
        userData: state.valueStory,
        user: state.default,
        content: state.content.spendAnalysis.accountParameters,
        validation: state.content.validation,
        Industries: state.content.discovery.form.industries,
        spendDetails: state.spendDetails,
        saveSpendParametersAfterRedirect : state.saveSpendParametersOnRedirect.changes,
        waveRecalcAfterRedirect : state.isWaveRecalcOnSpendParamRedirect.changes,
        tabMessage: state.content.spendAnalysis.detailedFile,
        discovery: state.content.discovery.form,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getYourFileLoading: bool => dispatch(getYourFileLoading(bool)),        
        UpdateRequestParameter: requestDetails => dispatch(UpdateRequestParameter(requestDetails)),
        currentActiveRequest: (requestDetails) => dispatch(currentActiveRequest(requestDetails)),
        solutionScopeChanged: (val) => dispatch(solutionScopeChanged(val)),
        pendingChanges: (val) => dispatch(pendingChanges(val)),
        fetchVisibleSolutionInScopeValues: () => dispatch(fetchVisibleSolutionInScopeValues()),
        isSpendParameterPage: obj => dispatch(isSpendParameterPage(obj)),
        saveSpendParametersOnRedirect: changes => dispatch(saveSpendParametersOnRedirect(changes)),
        FetchUpdateFieldVisibility: (data) => dispatch(FetchUpdateFieldVisibility(data)) ,
        updateRegion: (data) => dispatch(updateRegion(data)),
        isSavingTabVisible:(obj)=>dispatch(isSavingTabVisible(obj)),
        getSccPercentageEvaluation:(request)=> dispatch(getSccPercentageEvaluation(request)),        
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AccountParametersContainer)